<template>
    <div class="grafico-container" @fullscreenchange="teste">
        <ScaleLoader
            class="grafico"
            v-if="loading"
            :loading="loading"
        ></ScaleLoader>
        <div v-else class="grafico">
            <div class="header">
                <div class="row">
                    <div class="sm-7">
                        <div class="title">RESUMO DE BOLETOS</div>
                    </div>
                    <div class="sm-5 text-right">
                        <button @click="fullscreen" class="default-button">
                            <font-awesome-icon
                                fixed-width
                                :icon="faExpandAlt"
                            ></font-awesome-icon>
                        </button>
                        <button @click="showModal = true" class="default-button">
                            <font-awesome-icon
                                fixed-width
                                :icon="faCalendarAlt"
                            ></font-awesome-icon>
                        </button>
                    </div>
                </div>
                <div class="row flex justify-end">
                    <div class="sm-12 text-right padding text-grey">
                        {{ lista_meses[+dataMes] }}/{{ dataAno }}
                    </div>
                </div>
                <div class="row text-grey">
                    <div class="sm-12">
                        <table width="100%">
                            <tr>
                                <td>
                                    TOTAL QUITADOS:
                                    <strong>{{
                                        valor_quitado | number_format
                                    }}</strong>
                                </td>
                                <td align="right">
                                    TOTAL EM ABERTO:
                                    <strong>{{
                                        valor_aberto | number_format
                                    }}</strong>
                                </td>
                            </tr>
                        </table>

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="sm-12">
                    <label>
                        <input type="checkbox" v-model="mostrar_legendas" style="visibility: hidden;" />
                        <i class="mdi mdi-checkbox-marked mdi-18px" v-if="mostrar_legendas"></i>
                        <i class="mdi mdi-checkbox-blank-outline mdi-18px" v-else></i>
                        Mostrar Legendas
                    </label>

                </div>
            </div>
            <Chart :config="config"></Chart>
            <Modal
                v-if="showModal"
                @close="showModal = false"
                @confirmed="updateDatas"
            >
                <div class="row">
                    <div class="sm-12 md-6">
                        <select v-model="data_ano">
                            <option :value="i" v-for="i in years" :key="i">
                                {{ i }}
                            </option>
                        </select>
                    </div>
                    <div class="sm-12 md-6">
                        <select v-model="data_mes">
                            <option :value="i" v-for="i in meses" :key="i">
                                {{ `${i}`.padStart(2,'0') }}
                            </option>
                        </select>
                    </div>
                </div>
            </Modal>
        </div>
    </div>
</template>
<script>
import api from "/plugins/api";

import ScaleLoader from "vue-spinner/src/ScaleLoader";
import Chart from "./Chart.vue";
import Modal from "~/components/Modal.vue";

//import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons/faCalendarAlt";
import { faExpandAlt } from "@fortawesome/free-solid-svg-icons/faExpandAlt";

import moment from "moment";

const number_format = (value) => {
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
    }).format(+value);
};

export default {
    props: ["codigo_condominio", "codigo_cliente", "ano", "mes"],
    components: {
        ScaleLoader,
        FontAwesomeIcon: () => import("@fortawesome/vue-fontawesome").then(e => e.FontAwesomeIcon),
        Chart,
        Modal,
    },
    filters: {
        number_format,
    },
    data() {
        return {
            loading: false,
            mostrar_legendas: true,
            error: null,
            lista_meses: [
                "",
                "JANEIRO",
                "FEVEREIRO",
                "MARÇO",
                "ABRIL",
                "MAIO",
                "JUNHO",
                "JULHO",
                "AGOSTO",
                "SETEMBRO",
                "OUTUBRO",
                "NOVEMBRO",
                "DEZEMBRO",
            ],
            Ano: "",
            Mes: "",
            dataAno: "",
            dataMes: "",

            faCalendarAlt,
            faExpandAlt,

            showModal: false,

            valor_aberto: 0,
            valor_quitado: 0,
        };
    },
    computed: {
        years() {
            let start = +moment().format("YYYY");
            let years = [];
            let year = start;
            do {
                years.push(year);
                year--;
            } while (year > 1990);
            return years;
        },
        meses() {
            return [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
            ];
        },
        data_ano: {
            get() {
                return this.Ano;
            },
            set(value) {
                this.Ano = value;
            },
        },
        data_mes: {
            get() {
                return this.Mes;
            },
            set(value) {
                this.Mes = value;
            },
        },
        empresa() {
            return this.$store.state.empresa;
        },
        colors() {
            return this.empresa.colors;
        },
        cores() {
            return this.colors.dual;
        },
        config() {
            let labels = [`QUITADOS ${number_format(this.valor_quitado)}`, `EM ABERTO ${number_format(this.valor_aberto)}`];
            let data = [this.valor_quitado, this.valor_aberto];

            const getRandomColor = () => {
                var letters = "0123456789ABCDEF";
                var color = "#";
                for (var i = 0; i < 6; i++) {
                    color += letters[Math.floor(Math.random() * 16)];
                }
                return color;
            };

            //let backgroundColor = data.map(() => getRandomColor());
            let backgroundColor = this.cores;

            let config = {
                type: "pie",

                data: {
                    labels,
                    datasets: [
                        {
                            data,
                            backgroundColor,
                        },
                    ],
                },
                options: {
                    legend: {
                        position: "bottom",
                        display: this.mostrar_legendas,
                    },
                    tooltips: {
                        callbacks: {
                            label: (tooltipitem, data) => {
                                let { index } = tooltipitem;
                                let label = data.labels[index];
                                let value = data.datasets[0].data[index];
                                let valor = number_format(value);
                                valor = '';
                                return `${label} ${valor}`;
                            },
                        },
                    },
                },
            };

            return config;
        },
    },
    methods: {
        teste(e) {
            if (document.fullscreenElement) {
            } else {
                this.loading = true;
                this.$nextTick(() => {
                    this.loading = false;
                });
            }
        },
        fullscreen() {
            if (document.fullscreenElement) {
                document.exitFullscreen();
            } else {
                this.$el.requestFullscreen();
            }
        },
        updateDatas() {
            this.dataAno = this.Ano;
            this.dataMes = this.Mes;
            this.showModal = false;
        },
        async loadData() {
            this.loading = true;

            try {
                /*
                let { valor_aberto, valor_quitado } = await resumoBoleto({
                    CodCondominio: this.codigo_condominio,
                    CodCliente: this.codigo_cliente,
                    Ano: this.dataAno,
                    Mes: this.dataMes,
                });
                */

                let {
                    data: {
                        ValorAberto: valor_aberto,
                        ValorQuitado: valor_quitado,
                    },
                } = await api.get(
                    `condominios/${this.codigo_condominio}/indicadores/${this.dataAno}/${this.dataMes}/boleto`
                );

                this.valor_aberto = valor_aberto;
                this.valor_quitado = valor_quitado;

                //this.rows = records;
            } catch (err) {
                this.error = err.message;
                console.error("erro ", err);
            }

            this.loading = false;
        },
    },
    watch: {
        dataAno() {
            this.Ano = this.dataAno;
            this.loadData();
        },
        dataMes() {
            this.Mes = this.dataMes;
            this.loadData();
        },
        ano: {
            immediate: true,
            handler(value) {
                this.dataAno = value;
            },
        },
        mes: {
            immediate: true,
            handler(value) {
                this.dataMes = value;
            },
        },
    },
};
</script>
<style lang="less" scoped>
.grafico-container {
    
    width: 100%;
    margin-bottom: 1em;
    
}
.grafico {
    //padding: 1em;
    height: 100%;
    background-color: white;
    border: 1px solid lightgrey;
    border-radius: 0.5em;
    //margin: 0.5em;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    transition: 0.3s;
    position: relative;
    &:hover {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    }
    .header {
        padding-top: 1em;
    }
    .buttons {
        select {
            width: auto;
        }
        button {
            margin-left: 1em;
        }
    }
    .default-button {
        padding: 13px 13px;
    }
    .title {
        background-color: white;
        color: black;
    }
    .row {
        margin: auto !important;
    }
}
</style>
<style lang="less">
.vdatetime {
    margin: 0.5em;
    input.vdatetime-input {
        border: 1px solid #ddd;
        padding: 1em;
    }
}
</style>